import { Box } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';

interface TabPanelProps {
  value: number;
  index: number;
}

export const TabPanel: FunctionComponent<PropsWithChildren<TabPanelProps>> = ({
  value,
  index,
  children,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index ? <Box sx={{ p: 3 }}>{children}</Box> : null}
    </div>
  );
};
